import CheckoutBuyerForm from "./CheckoutBuyerForm";

export default CheckoutBuyerForm;
